import React, { useEffect, useState } from "react";
import { _findSelectOption, _getTranslation } from "../../utils/helper";

import { InputSelect } from "../../forms";

// key order is used to sort the months
// because on JSON.parse, it does not preserve the order of keys
const periodKeysOrder = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "q1",
  "q2",
  "q3",
  "q4",
];

const ProcurementAwardReports = (props) => {
  const [jsonData, setJsonData] = useState(null);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [availableTypes, setAvailableTypes] = useState([]);
  const [downloads, setDownloads] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [type, setType] = useState("");

  useEffect(() => {
    let reportData = props?.data?.json;
    if (reportData) {
      reportData = JSON.parse(reportData);
      setJsonData(reportData);

      const yearOptions = Object.keys(reportData).map((key) => ({
        value: key,
        label: key,
      }));

      // Latest year first
      setAvailableYears(yearOptions.reverse());
    }
  }, [props]);

  const handleYearChange = (yearVal) => {
    setYear(yearVal);
    setMonth("");
    setType("");
    setDownloads([]);

    if (yearVal) {
      const monthOptions = [];
      periodKeysOrder.forEach((keyOrder) => {
        const monthArray = jsonData[yearVal][keyOrder];
        if (monthArray) {
          monthOptions.push({
            value: keyOrder,
            label: monthArray[0]["monthLabel"],
          });
        }
      });
      setAvailableMonths(monthOptions);
    } else {
      setAvailableMonths([]);
    }
  };

  const handleMonthChange = (monthVal) => {
    setMonth(monthVal);
    setType("");
    setDownloads([]);

    if (monthVal) {
      const currentMonthArray = jsonData[year][monthVal];
      const typeOptions = currentMonthArray.map((item) => ({
        value: item.type,
        label: item.typeLabel,
      }));
      setAvailableTypes(typeOptions);

      // if only 1 type, auto set current type
      if (typeOptions.length === 1) {
        setType(typeOptions[0].value);
      }
    } else {
      setAvailableTypes([]);
    }
  };

  const handleTypeChange = (typeVal) => {
    setType(typeVal);
  };

  useEffect(() => {
    setDownloads([]);

    if (type) {
      const currentMonthArray = jsonData[year][month];
      if (Array.isArray(currentMonthArray) && currentMonthArray.length > 0) {
        const selectedTypeDownloads = currentMonthArray.filter(
          (item) => item.type === type
        );
        setDownloads(selectedTypeDownloads);
      }
    }
  }, [type, month, year]);

  return (
    <React.Fragment>
      {jsonData && (
        <React.Fragment>
          <InputSelect
            name="year-select"
            placeholder={`${_getTranslation("year")}`}
            options={availableYears}
            isClearable
            isSearchable
            value={_findSelectOption(availableYears, year)}
            onChange={(name, selectedValue) => {
              handleYearChange(selectedValue);
            }}
          />

          {year && (
            <React.Fragment>
              <InputSelect
                class="mt-4"
                name="month-select"
                placeholder="Month/Quarter"
                options={availableMonths}
                isClearable
                isSearchable
                value={_findSelectOption(availableMonths, month)}
                onChange={(name, selectedValue) => {
                  handleMonthChange(selectedValue);
                }}
              />

              {month && (
                <React.Fragment>
                  {(availableTypes.length > 1 ||
                    (availableTypes.length === 1 && type !== "none")) && (
                    <InputSelect
                      class="mt-4"
                      name="type-select"
                      placeholder="Type"
                      options={availableTypes}
                      isClearable
                      isSearchable
                      value={_findSelectOption(availableTypes, type)}
                      onChange={(name, selectedValue) => {
                        handleTypeChange(selectedValue);
                      }}
                    />
                  )}

                  {downloads.length > 0 && (
                    <div className="mt-4">
                      {downloads.map((post, index) => {
                        const fileUrl = post.fileUrl;
                        const mediaUrl = post.mediaUrl;
                        const downloadLink = fileUrl
                          ? fileUrl
                          : mediaUrl
                          ? mediaUrl
                          : null;

                        return (
                          <React.Fragment>
                            {downloadLink ? (
                              <a
                                key={index}
                                className="btn btn-s--pill w-full"
                                href={downloadLink}
                                target="_blank"
                                title={post.title}
                              >
                                {_getTranslation("download")}
                              </a>
                            ) : (
                              <div className="text-red-500 text-desktopXS font-semibold">
                                Awards for the selected timeframe do not exist
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ProcurementAwardReports;
